// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class FullSurveySessionByIdsPostRequest {
    static getAttributeTypeMap() {
        return FullSurveySessionByIdsPostRequest.attributeTypeMap;
    }
}
FullSurveySessionByIdsPostRequest.discriminator = undefined;
FullSurveySessionByIdsPostRequest.attributeTypeMap = [
    {
        "name": "ids",
        "baseName": "ids",
        "type": "Array<number>"
    }
];
//# sourceMappingURL=fullSurveySessionByIdsPostRequest.js.map